import React from "react";
import "./IntegrationHero.css";

export default function IntegrationHero() {
  return (
    <div id="integration-hero" className="outsourcemainclass">
      <div className="left">
        <h1>Continuous Integration (CI) Services</h1>
        <p>
          Accelerate software delivery with BastionEx’s robust DevOps Continuous Integration (CI) services. We help organizations automate code integration, testing, and validation to ensure faster releases, higher quality, and reduced deployment risks. Our CI solutions enable development teams to detect issues early, maintain code integrity, and deliver reliable applications at speed.
        </p>
     </div>
    </div>
  );
}
